// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.snt-form-name[data-v-c92b4568] {\n  max-width: 70%;\n}\n.app-style .v-input__slot[data-v-c92b4568]{\n  min-height: 36px;\n}\n", ""]);
// Exports
module.exports = exports;
